import { ApprovalStatusType } from 'app/model/constant';

export class ApprovalStatusModel {
  status: string;
  textStatus1: string;
  textStatus2: string;
  statusDate: string;
  textStatusDate: string;
  cssStatus: string;
}



// WEBPACK FOOTER //
// ./src/app/model/approval/approval-status.ts